import React, {Component} from 'react';
import {  AuthenticatedUser } from "../api";


class PageCloser extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();

        this.state = {
            loading: true,
            user: user,
            tData: this.props.tData,
            expanded: true,
            tone: this.props.tone ? this.props.tone : "info-text",
            symbol: this.props.symbol ? this.props.symbol : "fa fa-info"
        }

    }
    
    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if(prevProps !== this.props) {
  
        }
    }

    render() {
        const { tone, symbol } = this.state;
        const {header, message} = this.props;

        return (    
            <div className="container-fluid"> 
                <hr/>   
                <div className={tone}>
                    <i className={symbol} aria-hidden="true"></i>
                    <h3 style={{marginTop: "10px"}}>{header}</h3>
                    <p>{message}</p>                                                                                                                        
                </div>  
            </div>                           
        )
    }
}

export default PageCloser;